import { AnyObject } from '@lighthouse/core'
import { useState } from 'react'
import { useUpdateEffect } from 'react-use'

import { useFlowContainerContext } from '@/contexts/FlowContext'

export const useErrorMap = (dep?: AnyObject) => {
    const { errorMap } = useFlowContainerContext()
    const [state, setState] = useState(errorMap)
    useUpdateEffect(() => {
        setState(errorMap)
    }, [errorMap])

    useUpdateEffect(() => {
        setState(undefined)
    }, [dep])

    return state
}
